<template>
  <el-select
    v-if="platoons && platoons.length > 0"
    v-model="platoonId"
    class="bg-dark"
    placeholder="Select Platoon"
    size="large"
    @change="$emit('selected-platoon-id', platoonId)"
  >
    <el-option
      v-for="{ platoon_id, name } in platoons"
      :key="platoon_id"
      :label="name"
      :value="platoon_id"
    />
  </el-select>
</template>

<script>
import { ref, watch } from "vue";
import store from "@/store";
import Constants from "@/helpers/constants";

export default {
  name: "PlatoonDropdown",
  props: {
    allowAll: {
      type: Boolean,
      default: true,
    },
    selected: {
      type: Number,
      default: -1,
    },
  },
  emits: ["selected-platoon-id"],
  setup(props) {
    let platoonId = ref(props.selected);
    if (platoonId.value == -1 && !props.allowAll) {
      platoonId.value = "";
    }

    watch(
      () => props.selected,
      (current) => {
        if (current == -1 && !props.allowAll) platoonId.value = "";
        else platoonId.value = current;
      }
    );
    return { platoonId };
  },
  data() {
    return {
      platoons: [],
    };
  },
  created() {
    let loggedInUser = this.$store.getters["auth/getLoggedInUser"]();
    let platoonId = -1;
    if(loggedInUser.role && loggedInUser.role.role_id == Constants.ROLES.PLATOON_COMMANDER) {
      platoonId = loggedInUser.platoon_id;
    }

    store
      .dispatch("list/getPlatoons", { sort: "name", order: "asc",platoon_id: platoonId })
      .then((res) => {
        this.platoons = res.data;
        if (this.allowAll) {
          this.platoons.unshift({ platoon_id: -1, name: "All Platoons" });
        }
      });
  },
};
</script>

<style></style>
